import(/* webpackMode: "eager" */ "/home/runner/work/play/play/src/app/(root)/(protected)/external-wallets/page.tsx");
